export class Datasets {
    _datasets = [];
    addDataset(dataset) {
        this._datasets.push(dataset);
        return this;
    }
    getData() {
        const data = [];
        this._datasets.forEach((dataset) => {
            data.push(dataset.getConfig());
        });
        return data;
    }
}
//# sourceMappingURL=Datasets.js.map